import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import Gbtn from "../../../Components/buttons/Gbtn";
import DashNav from "../../../Components/DashNav/DashNav";
import Modal from "react-modal";
import { FiEdit } from "react-icons/fi";
import { RiSignalWifiErrorLine, RiDeleteBin6Line } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Components/LoadingSpinner/LoadingSpinner";
import noImage from "../../../Assests/avatar1.png";
import Contact from "../../../Components/SVGS/Contact";
import { deleteContact, getAllContacts } from "../../../api";
import { RxCross2 } from "react-icons/rx";

function ContactUsers() {
  const icon = () => {
    return <Contact width="30" height="34" fill="#DF2F35" />;
  };

  const location = useLocation();
  const CurrPage =
    location.state && location.state ? location.state.page : null;

  const [page, setPage] = useState(CurrPage !== null ? CurrPage : 1);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const [contactsData, setContactsData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [paginationDisplay, setPaginationDisplay] = useState("block");
  const [err, setErr] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [searchString, setSearchString] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    fetchContacts(page);
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchString.trim() !== "") fetchContacts(page, searchString);
    }, 1500);
    return () => {
      clearTimeout(delay);
    };
  }, [searchString]);

  useEffect(() => {
    Modal.setAppElement("#root");
  }, []);

  useEffect(() => {
    if (isDeleted) {
      fetchContacts(page, searchString);
      setIsDeleted(false);
    }
  }, [isDeleted]);

  const fetchContacts = (pageNumber, searchTxt) => {
    setisLoading(true);
    setErr(false);
    getAllContacts(limit, pageNumber, searchTxt)
      .then(({ data }) => {
        setisLoading(false);
        if (data.success) {
          setContactsData(data.result);
        } else {
          if (data.error_code === 2) {
            setContactsData(data.result);
            setErrorMsg(data.message);
            <div className="network-err-msg">{errorMsg}</div>;
          } else {
            setErr(true);
            console.log("get contact users err:", data);
            setErrorMsg(data.message);
          }
        }
      })
      .catch((err) => {
        setErr(true);
        setErrorMsg(err.message);
        setisLoading(false);
        console.log("get contact axios err", err);
      });
  };

  const handlePageChange = (pageNumber) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (pageNumber >= 1) {
      fetchContacts(pageNumber, searchString);
    }
  };

  const handleSearch = (e) => {
    setSearchString(e.target.value);
    if (e.target.value === "") {
      fetchContacts(page);
    }
  };

  return (
    <>
      <div className="mainDashView">
        <div>
          <DashNav svg={icon} DashboardNavText="Contact" />
        </div>

        <div className="dashPanel border-lt-Gray" style={{ padding: "4% 2%" }}>
          <div className="r-ViewBar">
            <div className="r-ViewBar2">
              <div>
                <input
                  type="search"
                  value={searchString}
                  onChange={handleSearch}
                  placeholder="Search"
                  className="rolesSearch"
                />
              </div>
            </div>
          </div>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              <div
                className="network-err-msg"
                style={{ display: err ? "flex" : "none" }}
              >
                {errorMsg}
              </div>
              {contactsData && contactsData.length > 0 ? (
                <div className="tableContainer">
                  <table className="roleViewTable" style={{ minWidth: "90%" }}>
                    <thead>
                      <tr>
                        <th>Actions</th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Organization Name</th>
                        <th style={{ paddingRight: "20px" }}>Message</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contactsData &&
                        contactsData.map((data) => (
                          <Rows
                            data={data}
                            page={page}
                            setIsDeleted={setIsDeleted}
                          />
                        ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="network-err-msg">{errorMsg}</div>
              )}
            </>
          )}
          <div className="paginationDiv" style={{ display: paginationDisplay }}>
            <Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalRecords}
              pageRangeDisplayed={3}
              onChange={(pageNumber) => {
                handlePageChange(pageNumber);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
const Rows = ({ data, page, setIsDeleted }) => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [err, setErr] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const deleteOnclick = () => {
    setModalIsOpen(true);
  };

  const deleteClick = () => {
    let obj = {
      id: data ? data.id : null,
    };
    deleteContact(obj)
      .then(({ data }) => {
        setErr(false);
        setIsLoading(true);
        if (data.success) {
          setModalIsOpen(false);
          setIsLoading(false);
          setIsDeleted(true);
          navigate("/dashboard/contactUsers", {
            state: { page: page },
          });
        } else {
          setErr(true);
          setErrMsg(data.message);
        }
      })
      .catch((Err) => {
        console.log("Delete role Error: ", Err);
        setErrMsg(err.message);
        setModalIsOpen(false);
        setErr(true);
        setIsLoading(false);
      });
  };

  // const [imgErr, setImgErr] = useState(false);

  // const handleImageErr = () => {
  //   setImgErr(true);
  // };

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        className="deleteModal animate__animated animate__zoomIn"
        style={{ display: "flex" }}
      >
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div
              className="delClient-cross"
              onClick={(e) => {
                setModalIsOpen(false);
              }}
            >
              <RxCross2 color="white" size={"20"} />
            </div>
            {err ? (
              <h3 className="network-err-msg">{errMsg}</h3>
            ) : (
              <>
                <h3 style={{ color: "white", marginBottom: "60px" }}>
                  Are you sure you want to delete?
                </h3>

                <Gbtn
                  text="Delete"
                  color="#EE282E"
                  radius="6px"
                  width="40%"
                  func={deleteClick}
                />
              </>
            )}
          </>
        )}
      </Modal>
      {data && data ? (
        <tr>
          <td
            style={{
              display: "flex",
              justifyContent: "center",
              minWidth: "60px",
            }}
          >
            <button onClick={deleteOnclick} className="Actionbtn delBtn">
              <RiDeleteBin6Line />
            </button>
          </td>
          {/* <td>
            <img
              src={imgErr ? noImage : data.image}
              onError={handleImageErr}
              alt=""
              height={"28"}
              width={"28"}
              style={{
                borderRadius: "100%",
                border: "1px solid lightgray",
                borderBlockColor: "lightgray",
              }}
            />
          </td> */}
          <td className="break-line-170">
            {data.name.length > 30
              ? data.name.substring(0, 30) + "..."
              : data.name}
          </td>
          <td className="break-line-170">{data.phone}</td>
          <td className="break-line-170">{data.email}</td>
          <td className="break-line-170">{data.organization_name}</td>
          <td className="break-line-270">
            {data.message.length > 150
              ? data.message.substring(0, 145) + "..."
              : data.message}
          </td>
        </tr>
      ) : null}
    </>
  );
};

export default ContactUsers;
